export const buildingUseTypesConfigESGBased = {
  Healthcare: {
    color: "#94DCF8",
    label: "Healthcare",
  },
  Hotel: {
    color: "#0070C0",
    label: "Hotel",
  },
  Logistics: {
    color: "#00FFFF",
    label: "Logistics",
  },
  Office: {
    color: "#4EA72E",
    label: "Office",
  },
  Residential: {
    color: "#104861",
    label: "Residential",
  },
  Retail: {
    color: "#FFC000",
    label: "Retail",
  },
};

export const buildingUsageConfig = {
  Rented: {
    color: "#4EA72E",
    label: "Average annual used area [m²]",
  },
  Vacant: {
    color: "var(--color-purpose-status-negative-subtle)",
    label: "Average annual vacant area [m²]",
  },
};

export const BUILDING_EVENTS_MIN_YEAR = 2025;
export const BUILDING_EVENTS_MAX_YEAR = 2050;
